@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/transcript-subtitles-panel/subtitle-block/clipping-studio-subtitle-block.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.subtitle-block {
  background: rgb(255, 255, 255);
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 10px;
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.08);
  font-family: "Open Sans", sans-serif;
}
.subtitle-block--selected {
  border-color: rgb(45, 187, 252);
  box-shadow: 0 0 0 1px rgb(41, 170, 229);
}
.subtitle-block__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.subtitle-block__timing {
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.35);
}
.subtitle-block__actions {
  display: flex;
  gap: 6px;
}
.subtitle-block__action-btn {
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
}
.subtitle-block__action-btn:hover {
  background: rgb(235, 240, 244);
}
.subtitle-block__action-btn--danger:hover {
  background: rgb(255, 255, 255);
  border-color: #ef5350;
  color: #ef5350;
}
.subtitle-block__text {
  width: 100%;
  min-height: 48px;
  padding: 8px 10px;
  font-size: 13px;
  line-height: 1.5;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  color: rgba(0, 0, 0, 0.85);
  resize: vertical;
  box-sizing: border-box;
}
/*# sourceMappingURL=clipping-studio-subtitle-block.component.css.map */
